import * as React from 'react';
import { Box } from '@mui/system';
import { Button, Typography } from '@mui/material';
import { ModalContext } from '@europrocurement/flexy-components';
import { MultiStepContextProps } from './types';

type FooterProps = MultiStepContextProps & {
    /** Erreur transverse bloquant l'enregistrement depuis n'importe quel onglet. */
    hasBlockingError?: boolean;
    /** Message décrivant l'erreur bloquante (affiché à côté du bouton). */
    blockingErrorMessage?: string;
};

const MultiStepFormFooter: React.FunctionComponent<FooterProps> = function (props) {
    const { multiStepForm, onCancel, hasBlockingError = false, blockingErrorMessage } = props;
    const {
        currentStep: { formContext },
        stepState: { isStepValid, isStepDisabled },
        onSave,
        isFormSubmitting,
    } = multiStepForm;
    const { modalActions } = React.useContext(ModalContext ?? null);

    // Annulation : navigation dédiée si fournie, sinon fermeture de la modale.
    const handleCancel = onCancel ?? modalActions?.reset;

    if (!formContext) {
        return null;
    }

    const saveStyle = { marginLeft: '20px', minWidth: '137px' };
    const disabledSaveStyle = {
        ...saveStyle,
        cursor: 'not-allowed',
        opacity: '0.4',
    };

    const isSaveDisabled = isFormSubmitting || isStepDisabled || hasBlockingError;
    const isSaveDimmed = !isStepValid || hasBlockingError;

    return (
        <Box
            marginTop="auto"
            sx={{ width: '100%' }}
        >
            <Box
                display="flex"
                justifyContent="flex-end"
                alignItems="center"
                marginTop="20px"
            >
                {hasBlockingError && blockingErrorMessage && (
                    <Typography
                        sx={{ color: 'warning.main', marginRight: '10px', fontSize: '0.875rem' }}
                    >
                        {blockingErrorMessage}
                    </Typography>
                )}
                <Button
                    sx={{ minWidth: '137px' }}
                    onClick={handleCancel}
                    variant="outlined"
                >
                    Annuler
                </Button>

                <Button
                    type="submit"
                    sx={isSaveDimmed ? disabledSaveStyle : saveStyle}
                    onClick={onSave}
                    variant="contained"
                    disabled={isSaveDisabled}
                >
                    Enregistrer
                </Button>
            </Box>
        </Box>
    );
};

export default MultiStepFormFooter;
